import json from "../json/forecastPredictions.json";

export default async () => JSON.parse(JSON.stringify(await json));
